import React, { useState } from "react";
import CompleteSyllabus from "./CompleteSyllabus";
import Assignment from "./Assignment";
import Placement from "./Placement";
import MyProfile from "./MyProfile";
import Navbar2 from "./NavBar2";
import "./StudentDashBoad.css";

const StudentDashBoad = () => {
  const [currentPage, setCurrentPage] = useState("CompleteSyllabus");

  const renderPage = () => {
    switch (currentPage) {
      case "Assignment":
        return <Assignment />;

      case "Placement":
        return <Placement />;

      case "MyProfile":
        return <MyProfile />;

      case "CompleteSyllabus":
      default:
        return <CompleteSyllabus />;
    }
  };

  return (
    <main className="student-dashboard-shell">
      <div className="student-dashboard-navbar">
        <Navbar2 setPage={setCurrentPage} currentPage={currentPage} />
      </div>

      <section className="student-dashboard-content">
        {renderPage()}
      </section>
    </main>
  );
};

export default StudentDashBoad;